import Utility from "./sframe/Utility";

let _sharingUrl: string = window.location.href;

let self: any,
  Sharer = self =
{
  setShareUrl(url: string)
  {
    _sharingUrl = url;
  },

  toFacebook(url?: string, hashtag: string = "", quote: string = "")
  {
    if (!url) url = _sharingUrl;

    // https://www.facebook.com/sharer.php?u=aminet.net&hashtag=%23amiga&quote=repository%20of%20amiga%20software

    let uri = encodeURIComponent(url),
      hashtagi = encodeURIComponent("#" + hashtag),
      quotei = encodeURIComponent(quote),
      openUrl = "https://www.facebook.com/sharer.php?u=" + uri + "&hashtag=" + hashtagi + "&quote=" + quotei;

    Utility.openWindowInCenter(openUrl, "_blank", 600, 500);
  },

  toLine(url?: string)
  {
    if (!url) url = _sharingUrl;

    // 注意分享需即時執行不能等 callback
    let uri = encodeURIComponent(url),
      openUrl = Utility.getMobileOperatingSystem() === "unknown" ?
        "https://social-plugins.line.me/lineit/share?url=" + uri :
        "line://msg/text/" + uri;

    Utility.openWindowInCenter(openUrl, "_blank", 600, 500);
  },

  copyOrNavigatorShare(url?: string)
  {
    if (!url) url = _sharingUrl;

    self.navigatorShare(url, (error: string) =>
    {
      console.log("navigator share: " + error);

      if (error === "unsupported") {
        self.copy(url);
      }
    });
  },

  copy(url?: string)
  {
    if (!url) url = _sharingUrl;

    Utility.copyTextToClipboard(url, (success: boolean) =>
    {
      if (success) {
        alert("網址已複製到剪貼板, 您可以直接貼上分享");
      }
      else {
        alert("複製網址失敗");
      }
    });
  },

  navigatorShare(url?: string, cb?: Function)
  {
    if (!url) url = _sharingUrl;

    console.log(navigator.share);

    if (navigator.share) {
      navigator.share({
        title: document.title,
        //   text: '文字描述',
        url: url,
      })
        .then(() => { if (cb) cb.call(null, ""); })
        .catch((error) =>
        {
          console.log('發生錯誤', error);
          if (cb) cb.call(null, "share fail");
        });
    }
    else {
      if (cb) cb.call(null, "unsupported");
    }
  }
};

export default Sharer;